import AbortController from 'abort-controller';

import { routeToSpecificScope } from '../../helpers/helpersts';

import { addLoadingFlag, changeMessageLoading, subLoadingFlag } from './loading';
import { requestData } from '../../config/services/datasets';
import { SERVER } from '../../config/server.config';
import { paramBuilder } from '../../helpers/helpers';
import { replaceHighlightsDataEvent, toDataEvents, updateMetaDataEvent, replaceZonesThresholdsDataEvent } from './dataEvents';
import { CONTROLLER_SET, MESSAGES, PAST } from '../../config/constants';
import { AppThunk } from '../../config/commonTypes';
import { DataPlayerEventsPractices, PracticesAction, PracticesState, PracticeType } from '../types';

export const replaceAllPractices = (practices: PracticesState) => {
  return {
    type: PracticesAction.REPLACE_ALL_PRACTICES,
    practices
  };
};

export const getPracticesByGameId = (teamId: string, loader: boolean): AppThunk => {
  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const scope = routeToSpecificScope(path);
    const params = getState().filters[scope] ? JSON.parse(JSON.stringify(getState().filters[scope])) : {};
    if (loader) {
      dispatch(addLoadingFlag(scope));
    }
    const controller = new AbortController();
    CONTROLLER_SET.add(controller);
    //PRACTICES_PAGE_CONTROLLERS.push(controller);
    const results = await requestData(SERVER.PRACTICES(teamId) + paramBuilder(params), { signal: controller.signal as AbortSignal });
    CONTROLLER_SET.delete(controller);
    if (results && results.length && results.length !== 0) {
      const response = results.map((practice: PracticeType) => {
        return {
          ...practice,
          homeTeamId: teamId,
          gameId: practice.dsid,
        };
      });
      dispatch(replaceAllPractices(response));
      // BEGIN DataEvents
      // TODO: Fix the type:
      const practices: DataPlayerEventsPractices = results.map((practice: PracticeType) => toDataEvents({ ...practice, status: PAST }));
      practices.forEach((practice) => {
        dispatch(updateMetaDataEvent(practice.meta.gameId, practice.meta));
        dispatch(replaceHighlightsDataEvent(practice.meta.gameId, practice.highlights));
        dispatch(replaceZonesThresholdsDataEvent(practice.meta.gameId, practice.zones));
      });
      // END Data Events
    } else if (!controller.signal.aborted) {
      dispatch(changeMessageLoading(scope, MESSAGES.EMPTY));
    }
    if (loader) {
      dispatch(subLoadingFlag(scope));
    }
  };
};

export const loadPractices = (loader: boolean): AppThunk => {
  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const scope = routeToSpecificScope(path);
    const teamId: string = getState().filters[scope]?.teamId ??  getState().user?.teamId ??"";
    // const teamId = 4500;
    //const teamId = 3701;
    dispatch(getPracticesByGameId(teamId, loader));
  };
};
